import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatNumber } from '../utils/helpers';

const DiferenciaTotal = ({ resumen }) => {
  // Calcular diferencia con el neto
  const diferenciaConNeto = (resumen?.totalDB || 0) - (resumen?.totalNetoMP || 0);

  return (
    <Box
      sx={{
        p: 4,
        textAlign: 'center',
        bgcolor: '#f5f9ff',
        borderRadius: 2,
        border: '2px solid #1976d2',
        minHeight: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6" color="textSecondary" gutterBottom>
        Diferencia Total
      </Typography>
      
      {/* Diferencia con Bruto */}
      <Typography
        variant="h2"
        sx={{
          fontWeight: 700,
          color: Math.abs(resumen?.diferencia || 0) > 1000 ? '#d32f2f' : '#1976d2',
          mb: 1,
        }}
      >
        ${Math.abs(resumen?.diferencia || 0).toLocaleString()}
      </Typography>
      <Typography variant="caption" color="textSecondary" sx={{ mb: 2 }}>
        (Sistema vs Bruto MP)
      </Typography>

      {/* Diferencia con Neto */}
      {/* <Typography
        variant="h3"
        sx={{
          fontWeight: 600,
          color: Math.abs(diferenciaConNeto) > 1000 ? '#d32f2f' : '#2e7d32',
          mb: 2,
        }}
      >
        ${Math.abs(diferenciaConNeto).toLocaleString()}
      </Typography>
      <Typography variant="caption" color="textSecondary" sx={{ mb: 3 }}>
        (Diferencia vs Neto MP)
      </Typography> */}

      <Box sx={{ display: 'flex', gap: 4, mt: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Box>
          <Typography variant="body2" color="textSecondary">
            Total Sistema
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#ed6c02' }}>
            ${resumen?.totalDB ? formatNumber(resumen.totalDB) : '0'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="textSecondary">
            Total MP (Bruto)
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#1976d2' }}>
            ${resumen?.totalMP ? formatNumber(resumen.totalMP) : '0'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="textSecondary">
            Total MP (Neto)
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#2e7d32' }}>
            ${resumen?.totalNetoMP ? formatNumber(resumen.totalNetoMP) : '0'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DiferenciaTotal;